<template>
  <div class="h-400px overflow-y-auto">
    <template v-if="listaLinhas.length > 0">
      <v-list-item class="p-0 ma-0 ml-n4">
        <v-btn
          v-if="linhasLinhas.length === listaLinhas.length"
          icon
          @click="desmarcarTodasLinhas"
        >
          <v-icon color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-btn v-else icon @click="selecionarTodasLinhas">
          <v-icon v-if="linhasLinhas.length > 0" color="primary">mdi-minus-box</v-icon>
          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-list-item-title class="font-weight-bold">{{ txtBotaoSelecionarTodos }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-for="item in listaLinhas" :key="item.id" class="p-0 ma-0 ml-n4">
        <v-btn v-if="linhasLinhas.includes(item.id)" icon @click="desSelecionarLinha(item)">
          <v-icon color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-btn v-else icon @click="selecionarLinha(item)">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-list-item-title :title="`${item.descricao} (${item.qtd_produto})`">
          {{ item.descricao }} ({{item.qtd_produto}})
        </v-list-item-title>
      </v-list-item>
    </template>

    <span v-else class="pl-2 text-gray-100">Não há linhas</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import api from "@/api/api";
import {logout} from "@/helpers";

export default {
  name: "Segmentos",
  props: {
    id_comprador: {
      type: [Number, String]
    }
  },
  data: () => ({
    menu: false,
    listaLinhas: [],
    cfgSystemIgnorarMovimentacaoFiltroLinhas: false,
  }),
  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
      linhasLinhas: "linhasCompra/getItens"
    }),
    txtBotaoSelecionarTodos () {
      return this.linhasLinhas.length === this.listaLinhas.length ? 'DESMARCAR TODOS' : 'MARCAR TODOS'
    },
    linhasFiltradas() {
      if (this.cfgSystemIgnorarMovimentacaoFiltroLinhas) return this.listaLinhas;
      return this.listaLinhas.filter(f => f.com_movimento == 'S');
    }
  },
  watch: {
    fornecedorCompra () {
      this.buscarListaDeLinhas()
    }
  },
  mounted() {
    this.buscarListaDeLinhas()
  },
  destroyed() {
    this.desmarcarTodasLinhas()
  },
  methods: {
    selecionarLinha ({id}) {
      this.$store.dispatch("linhasCompra/adicionar", id)
    },
    desSelecionarLinha ({id}) {
      this.$store.dispatch("linhasCompra/remover", id)
    },
    selecionarTodasLinhas () {
      this.$store.dispatch(
        "linhasCompra/adicionarTodos",
        this.Helpers.arrayColumn(this.linhasFiltradas, 'id')
      )
    },
    desmarcarTodasLinhas () {
      this.$store.dispatch("linhasCompra/resetar")
    },
    buscarListaDeLinhas () {
      const params = {
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        id_fornecedor: this.fornecedorCompra.id,
        id_comprador: this.id_comprador
      }

      api.get('fornecedores/linhas', {params})
        .then(resposta => {
          this.listaLinhas = resposta.data.linhas;
          this.cfgSystemIgnorarMovimentacaoFiltroLinhas = resposta.data.ignorar_movimentacao_filtro_linhas;
          this.selecionarTodasLinhas();
        })
        .catch(logout)
    }
  }
}
</script>
